module.exports = __webpack_public_path__ + "media/images/pic/lectors/aneta-i-katarzyna-ea699305114522bf9741e11d7a3218b7.jpeg";